'use client'

import { useEffect } from 'react'

/**
 * Completes the initial load circular progress and removes it when the app mounts.
 * The loader is rendered in index.html and animates 0-90% via CSS before JS loads.
 */
export function InitialLoadBar() {
  useEffect(() => {
    const container = document.getElementById('initial-load-bar')
    const progress = document.getElementById('initial-load-progress')
    const percentEl = document.getElementById('initial-load-percent')
    if (!container || !progress) return

    // Complete to 100% (stroke-dashoffset 0 = full circle)
    progress.style.animation = 'none'
    progress.style.setProperty('stroke-dashoffset', '0')
    progress.style.transition = 'stroke-dashoffset 0.25s ease'
    if (percentEl) percentEl.textContent = '100%'

    // Remove after short delay
    const timeout = setTimeout(() => {
      container.style.opacity = '0'
      container.style.transition = 'opacity 0.2s ease'
      setTimeout(() => container.remove(), 200)
    }, 250)

    return () => clearTimeout(timeout)
  }, [])

  return null
}
